import ApiCall from "../../../../utils/apiCall";

export async function getAutocomplete({ keyword }) {
  return await ApiCall.get(
    `/suppliers/listings/autocomplete?keyword=${keyword}`
  );
}



// WEBPACK FOOTER //
// ./src/newDropshipperApp/module/suppliers/listings/autocomplete.js